var _rect, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 780,
    viewBox: "0 0 360 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 884,
    transform: "translate(-22.6909 -15.2188)",
    fill: "url(#paint0_radial)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.309,
    cy: 789.781,
    rx: 124,
    ry: 79,
    fill: "#EEB7E7",
    fillOpacity: 0.4,
    filter: "url(#blur)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blur",
    x: -80.6909,
    y: 510.781,
    width: 648,
    height: 558,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-366.5 -493) rotate(61.8345) scale(1865.38 1865.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE8B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593934,
    stopColor: "#0D0616"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.74d9b84da455fa9e9b61be8f50bde80a.svg";
export { ForwardRef as ReactComponent };